import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PriceDTO } from "../../../domain/models/dto/PriceDTO";
import currencyServiceFactory, { CurrencyServiceImpl } from "../../../services/CurrencyServiceImpl";

interface CurrencyAmountProps {
    price?: PriceDTO;
    suffix?: string;
}

const currencyService = currencyServiceFactory();

const CurrencyAmount: FC<CurrencyAmountProps> = ({ price, suffix = "" }) => {
    const { t } = useTranslation();
    const [target, setTarget] = useState(currencyService.currentCurrency);

    useEffect(() => {
        const subscription = CurrencyServiceImpl.currency$.subscribe(setTarget);
        return () => subscription.unsubscribe();
    }, []);

    if (!price) return <>{t("currencies.conversionUnavailable")}</>;
    const conversion = currencyService.convertCurrency(price, target);
    if (!conversion.available) {
        return <>{t("currencies.conversionUnavailable")}</>;
    }

    return (
        <>
            {conversion.price.amount.toFixed(2)} {t(`currencies.short.${conversion.price.currency}`)}{suffix}
        </>
    );
};

export default CurrencyAmount;
